<div class="container">
    <app-navbar></app-navbar>
    <app-shared-loading *ngIf="loading"></app-shared-loading>
    <div id="ticketDiv">
        <div class="voucherBox" id="voucherBox">
          <p class="topMsg">{{ 'payment-Receipt-Title' | translation | async }}</p>
          <img src="assets/images/payvalida.svg" alt="Payvalida, pasarela de pagos" title="Payvalida, pasarela de pagos" class="voucherLogo"/>
         <div *ngIf="this.showVoucher" class="voucherInfo">
          <div class="leftInfoVoucher">
                  <h1 class="approved"> {{ status | translation | async }} </h1>
                  <h2>{{ transactionDetails?.MERCHANT_NAME }}</h2>
                  <br>
                  <p>{{ 'date-title' | translation | async }} {{ currentDate }}</p>
                  <p class="reference" *ngIf="transactionDetails?.ORDER_REFERENCE != null">
                      <b>{{ 'reference-label' | translation | async }}:</b> {{ transactionDetails?.ORDER_REFERENCE }}
                  </p>
                  <br>
                  <div class="flexBox">
                      <div class="column">
                          <b>{{ 'html-Total-Title' | translation | async }}:</b>
                      </div>
                      <div class="column">
                          <b>{{ transactionDetails?.ORDER_AMOUT | number : '1.2-2' }} {{ transactionDetails?.ORDER_CURRENCY }}</b>
                      </div>
                  </div>
                  <br>
              </div>
              <p class="voucherFooter">{{ 'no-Print-Receipt' | translation | async }}</p>
              <br>
              <app-buttons-bar [valid]="true" (PR)="printPaymentReceipt()"></app-buttons-bar>
          </div>
          <div *ngIf="!this.showVoucher" class="pendingInfo">
            <div class="retryConfirmation">
             {{'process-Order-Info-Title' | translation | async}} <b>{{ timeIntervalToRequestAgain }}</b> {{('html-Seconds-Title' | translation | async) | lowercase}}.
            </div>
          </div>
        </div>
        <div *ngIf="transactionDetails != null && transactionDetails?.MERCHANT_URL_RETURN != ''">
            <a class="returnMerchant" [href]="transactionDetails?.MERCHANT_URL_RETURN"><fa-icon icon="arrow-left" size="lg"></fa-icon>
              {{ 'return-to' | translation | async }} {{transactionDetails?.MERCHANT_NAME}}</a>
        </div>
    </div>
</div>
